var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{class:{ 'dashboard-main': _vm.isDashboardRoute }},[_c('div',{class:['route-shell', { 'route-shell--dashboard': _vm.isDashboardRoute }]},[_c('router-view')],1),_c('notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }